import defaultTheme from '../../../Template/theme'
import components from './components'

const theme = {
  ...defaultTheme,
  components
}

export {theme}
export default theme



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/theme/index.js